<template>
    <div>
        <div class="w-full flex-col shadow-md pb-2 mb-4 bg-white rounded mr-8">
            <div class="flex border-b-2 border-followup-nav text-grey-darkest rounded-t p-2 justify-between">
                <span class="pl-2">Activity Logs</span>
            </div>
            <div v-if="activities.length > 0" v-for="(log, index) in activities">
                <div v-if="log.description.length > 0"
                     class="px-3 flex-col text-grey-darkest border-b-1 py-3 hover:bg-grey-lighter" :key="`log-${index}`">
                    <div class="flex flex-wrap flex-md-nowrap md:justify-between text-sm mb-2">
                        <div class="flex flex-wrap flex-md-nowrap">
                            <div class="mr-4 w-full md:w-auto">{{ (log.created_at) ? createdTime(log.created_at) : ''  }}</div>
                            <div class="w-full md:w-auto"><span>{{ log.log_name }}</span></div>
                        </div>
                        <div class="w-full md:w-auto">
                            <span>Created by: </span><span class="text-grey-darkest font-medium">{{ log.creator }}</span>
                        </div>
                    </div>
                    <div class="flex justify-between">
                        <div v-if="log.log_name != 'Activity'" class="leading-tight md:mr-32 text-grey-darkest">
                            <div v-html="log.description"></div>
                        </div>
                        <div v-else class="leading-tight md:mr-32 text-grey-darkest">
                            <div v-html="log.description"></div><span v-if="log.sales_behaviour_date">{{(log.sales_behaviour_time) ? createdTime(log.sales_behaviour_date+'T'+log.sales_behaviour_time+'Z'):createdDate(log.sales_behaviour_date)}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "contact-activity-logs",
    props: ['contact','currentUserId'],
    components: {},
    data() {
        return {
            activities: []
        }
    },
    created() {

    },
    mounted() {
        this.getLogs();
    },
    computed: {

    },
    methods: {
        getLogs(){
            axios.post(route('company-contact.list-logs'), {
                contactId: this.contact.id
            }).then((response) => {
                this.activities = response.data;
            });
        },
        createdTime(createdTime){
            console.log(createdTime);
            return moment.utc(createdTime).local().format('MM/DD/YYYY hh:mm A')
        },
        createdDate(createdTime){
            return moment.utc(createdTime).local().format('MM/DD/YYYY')
        }

    }
}
</script>
